import React from "react";
import {
  Radio,
  FormControl,
  FormLabel,
  RadioProps,
  Typography,
  Box,
  RadioGroup,
  FormControlLabel
} from "@mui/material";
import { fontFamily_medium, fontFamily_regular, sfUIDisplayMedium } from "@/utils/fonts";
import colors from "@/utils/colors";
import { styled } from '@mui/material/styles';
import UIText from "@/components/text/UIText";

interface NowoRadioButtonProps {
  titleLabel?: string;
  value: string;
  textSize?: TSizes;
  options?: Option[];
  handleChange?: (value: string) => void;
  sx?: any;
  disabled?: boolean;
}

export const sizes = [
  "text-xs",
  "text-s",
  "text-md",
  "text-lg",
  "text-xl",
  "text-2xl",
  "display-sm",
  "display-md",
  "display-lg",
  "display-xl",
  "display-xxl",
] as const;

type TSizes = (typeof sizes)[number];

interface Option {
  value: string;
  id: string;
  disabled?: boolean;
  checked?: boolean;
}



const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow: 'inset 0 0 0 1px rgba(208, 213, 221, 1)',
  backgroundColor: colors.white,
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5',
  },
  'input:disabled ~ &': {
    background: colors.gray100,
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: colors.white,
  boxShadow: `inset 0 0 0 1px ${colors.primaryAserta}`,
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&::before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage: 'radial-gradient(#155EEF,#155EEF 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    boxShadow: 'inset 0 0 0 1px rgba(21, 94, 239, 1)',
    backgroundColor: colors.white,
  },
});

// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
  return (
    <Radio
      disableRipple
      color="default"
      size="small"
      {...props}
      sx={{
        color: colors.primaryAserta,
        '&.Mui-checked': {
        color: colors.primaryAserta,
        }
      }
      }
    />
  );
}


const UIRadioButton = ({
  titleLabel,
  value,
  textSize = "text-md",
  handleChange,
  options,
  sx,
  disabled = false
}: NowoRadioButtonProps) => {
  return (
    <FormControl sx={{ ...sx }}>
      <FormLabel id="demo-customized-radios" className={fontFamily_medium.className} sx={{
        fontSize: 14, "&.Mui-focused": { color: colors.gray700 }
      }}>{titleLabel}</FormLabel>
      <RadioGroup
        row
        defaultValue={value}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        onChange={(event) => {
          if (handleChange)
            handleChange((event.target as HTMLInputElement).value)
        }}
        value={value}
        sx={{ justifyContent: 'space-between' }}

      >
        {options?.map((option) => (
          <FormControlLabel
            key={option.id}
            value={option.value}
            label={<UIText text={option.value} size={textSize} color={"blue"} />}
            sx={{
              fontSize: 14,
              fontFamily: fontFamily_regular
            }}
            control={<BpRadio disabled={disabled || option.disabled} checked={option.checked} />} />
        ))}

      </RadioGroup>
    </FormControl>
  );
};

export default UIRadioButton;

